import Typography from '@classify/react-core-components/Typography';
import { Link, LINK } from '@openclassrooms/ui-web/links';

import { Link as RouterLink } from 'react-router-dom';
import { getActiveLocale } from '@openclassrooms/translations';
import withStyles from '@mui/styles/withStyles';

const styles = ({ typography }) => ({
  icon: {
    color: typography.body2.color,
  },
});

const MainHeaderNavigationLink = ({
  children = null,
  isLegacy = false,
  className = '',
  path = '',
  content = '',
  dataEvent = '',
  shouldUseHref = false,
  variant = 'body',
  dataTestId = '',
  onClickAction = null,
  linkAttributes = {},
}) => {
  let linkProps = {};

  if (isLegacy || shouldUseHref) {
    linkProps = {
      href: `/${getActiveLocale()}${path}`,
    };
  } else {
    linkProps = {
      Component: RouterLink,
      to: path,
    };
  }

  return (
    <Link
      {...linkProps}
      {...linkAttributes}
      className={className}
      data-event={dataEvent}
      variant={LINK.VARIANT.HEADER}
      data-testid={dataTestId}
      onClick={onClickAction}
    >
      {content ? (
        <Typography component="span" variant={variant}>
          {content}
        </Typography>
      ) : (
        children
      )}
    </Link>
  );
};

export default withStyles(styles)(MainHeaderNavigationLink);
